import {IUnderstandApiState} from "../../Models/IUnderstandApiState";
import {
    FETCH_IUNDERSTAND_REQUEST,
    FETCH_IUNDERSTAND_SUCCESS,
    FETCH_IUNDERSTAND_FAILURE
  } from './IUnderstandTypes';
  
  const initialState: IUnderstandApiState = {
    loading: false,
    success: true,
    error: '',
  };
  
  const IUnderstandReducer = (
    state = initialState,
    action: any
  ): IUnderstandApiState => {
    switch (action.type) {
      case FETCH_IUNDERSTAND_REQUEST:
        return { ...state, loading: true };
      case FETCH_IUNDERSTAND_SUCCESS:
        return { ...state, loading: false, success: action.payload, error: '' };
      case FETCH_IUNDERSTAND_FAILURE:
        return { ...state, loading: false, success: false, error: action.payload };
      default:
        return state;
    }
  };
  
  export default IUnderstandReducer;